import Carousel from "../components/Carousel";
import SectionHeading from "../components/SectionHeading";
import Reveal from "../components/Reveal";
import GridTexture from "../components/GridTexture";

// Import channel / streaming logos
import bbc from "../assets/cover/chaine/bbc.png";
import disco from "../assets/cover/chaine/disco.png";
import espn from "../assets/cover/chaine/espn.png";
import fg from "../assets/cover/chaine/fg.jpg";
import film from "../assets/cover/chaine/film.png";
import fubo from "../assets/cover/chaine/fubo.png";
import national from "../assets/cover/chaine/national.png";
import npo from "../assets/cover/chaine/npo.png";
import par from "../assets/cover/chaine/par.png";
import prime from "../assets/cover/chaine/prime.png";
import rtl from "../assets/cover/chaine/rtl.png";
import sbs from "../assets/cover/chaine/sbs.png";
import sdc from "../assets/cover/chaine/sdc.png";
import sky from "../assets/cover/chaine/sky.png";
import spi from "../assets/cover/chaine/spi.png";
import talpa from "../assets/cover/chaine/talpa.png";
import vrt from "../assets/cover/chaine/vrt.png";
import ziggo from "../assets/cover/chaine/ziggo1.png";

// Dynamically import all film images in assets/cover/film
const filmContext = require.context("../assets/cover/film", false, /\.(png|jpe?g|svg|webp)$/);
const filmImages = filmContext.keys().map((key) => filmContext(key));

const chaineLogos = [
  { name: "Ziggo Sport", src: ziggo },
  { name: "ESPN", src: espn },
  { name: "NPO Start", src: npo },
  { name: "VRT MAX", src: vrt },
  { name: "Prime Video", src: prime },
  { name: "BBC", src: bbc },
  { name: "Discovery+", src: disco },
  { name: "Fubo", src: fubo },
  { name: "National Geographic", src: national },
  { name: "Paramount+", src: par },
  { name: "RTL", src: rtl },
  { name: "SBS", src: sbs },
  { name: "Sky", src: sky },
  { name: "Talpa", src: talpa },
  { name: "Filmbox", src: film },
  { name: "FG", src: fg },
  { name: "SDC", src: sdc },
  { name: "SPI", src: spi },
];

export default function Chaine() {
  return (
    <section
      id="films"
      className="py-14 sm:py-20 bg-surface-secondary relative overflow-hidden"
      style={{ "--section-bg": "#000000" }}
    >
      <GridTexture />
      <div className="main-content w-[90%] sm:w-[90%] md:w-[85%] m-auto relative">
        <SectionHeading
          kicker="Films, series & zenders"
          title={
            <>
              Onbeperkt streamen van de nieuwste{" "}
              <span className="text-transparent bg-clip-text bg-gradient-text">
                films, series &amp; live TV
              </span>
            </>
          }
          subtitle="Geniet van premium content van de beste streamingplatforms in één abonnement"
        />

        {/* Movies & series poster carousel */}
        <Reveal>
          <Carousel
            items={filmImages}
            keyExtractor={(src) => src}
            speed={1}
            renderItem={(src, index) => (
              <div className="w-40 h-64 sm:w-48 sm:h-72 md:w-52 md:h-[22rem] rounded-2xl overflow-hidden border border-line shadow-md hover:shadow-glow-cyan-sm hover:border-accent/50 transition-all duration-500 group">
                <img
                  src={src}
                  alt={`Film of serie poster ${(index % filmImages.length) + 1}`}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  loading="lazy"
                  draggable={false}
                />
              </div>
            )}
          />
        </Reveal>

        {/* Streaming services / channel logos */}
        <div className="mt-12 sm:mt-16">
          <p className="text-center text-xs sm:text-sm font-bold uppercase tracking-[0.18em] text-ink-muted mb-6">
            Inclusief de grootste zenders &amp; streamingdiensten
          </p>
          <Carousel
            items={chaineLogos}
            keyExtractor={(logo) => logo.name}
            speed={0.4}
            direction="reverse"
            gapClassName="gap-3 sm:gap-4"
            renderItem={(logo) => (
              <div className="w-24 sm:w-28 bg-white rounded-lg sm:rounded-xl p-3 sm:p-4 shadow-md hover:shadow-glow-cyan-sm transition-all duration-300 hover:scale-105 border border-white/10 hover:border-accent/40">
                <div className="flex items-center justify-center h-7 sm:h-8">
                  <img
                    src={logo.src}
                    alt={logo.name}
                    className="max-h-7 sm:max-h-8 max-w-full object-contain"
                    loading="lazy"
                    draggable={false}
                  />
                </div>
              </div>
            )}
          />
        </div>
      </div>
    </section>
  );
}
